import fetch from 'utils/fetch';
import { createAction } from 'redux-actions';

export const requestFormAction = createAction('REQUEST_FORM');
export const receiveFormAction = createAction('RECEIVE_FORM');
export const caseNameUpdateAction = createAction('FORM_CASE_NAME_UPDATE');
export const updateInterventionDateAction = createAction(
  'UPDATE_PLANNING_DATE'
);
export const updateInterventionTimeAction = createAction(
  'UPDATE_PLANNING_TIME'
);
export const updatePreInterventionDateAction = createAction(
  'UPDATE_PREPLANNING_DATE'
);
export const updateDurationAction = createAction('UPDATE_DURATION');
export const updateDurationUnitAction = createAction('UPDATE_DURATION_UNIT');
export const updateWorkerIdAction = createAction('UPDATE_WORKER_ID');
export const updateSecondaryWorkerIdsAction = createAction(
  'UPDATE_SECONDARY_WORKER_IDS'
);
export const updateBuildingSurfaceAction = createAction(
  'UPDATE_BUILDING_SURFACE'
);
export const updateGroundSurfaceAction = createAction('UPDATE_GROUND_SURFACE');

import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

function fetchForm(id) {
  return dispatch => {
    dispatch(requestFormAction());
    fetch(`/pco-manager/aast/cases/${id}/contract/accept`)
      .then(r => r.json())
      .then(nodes => {
        dispatch(receiveFormAction(nodes));
      });
  };
}

function shouldFetchForm(id, state) {
  const form = state.form;

  if (form.id === undefined && id > 0 && !form.isFetching) {
    return true;
  }

  return false;
}

export const fetchFormIfNeeded = id => (dispatch, getState) => {
  const state = getState();
  if (shouldFetchForm(id, state)) {
    dispatch(fetchForm(id));
  }
};

export const updateInterventionDate = date => (dispatch, getState) => {
  var computedDate =
    date && date.date ? moment(date.date).format(DATE_FORMAT) : null;
  dispatch(updateInterventionDateAction(computedDate));
};

export const updateInterventionTime = time => (dispatch, getState) => {
  dispatch(updateInterventionTimeAction(time));
};

export const updatePreplanningDate = date => (dispatch, getState) => {
  dispatch(updatePreInterventionDateAction(date));
};

export const updateDuration = duration => (dispatch, getState) => {
  dispatch(updateDurationAction(duration));
};

export const updateDurationUnit = unit => (dispatch, getState) => {
  dispatch(updateDurationUnitAction(unit));
};

export const updateWorkerId = id => (dispatch, getState) => {
  dispatch(updateWorkerIdAction(id));
};

export const updateSecondaryWorkerIds = ids => (dispatch, getState) => {
  dispatch(updateSecondaryWorkerIdsAction(ids));
};

export const updateBuildingSurface = value => (dispatch, getState) => {
  dispatch(updateBuildingSurfaceAction(value));
};

export const updateGroundSurface = value => (dispatch, getState) => {
  dispatch(updateGroundSurfaceAction(value));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/actions/form.js